import React from 'react';
import { SEAT_PRICE } from '../utils/peopleUtils';

export function SeatPrompt({ seatPrompt, inviteBusy, onConfirm, onDismiss }) {
  return (
    <section className="settings-modal__section settings-people__seat">
      <h3 className="settings-people__title">
        Add a seat for {seatPrompt.email} for an extra ${SEAT_PRICE}/mo?
      </h3>
      <p className="settings-people__meta">
        Your plan for this brain will change from $
        {SEAT_PRICE * seatPrompt.seats}/mo to $
        {SEAT_PRICE * (seatPrompt.seats + 1)}/mo.
      </p>
      <div className="settings-people__actions">
        <button
          type="button"
          className="settings-modal__action-btn settings-modal__action-btn--primary"
          disabled={inviteBusy}
          onClick={onConfirm}
        >
          {inviteBusy ? 'Adding seat…' : 'Add seat & invite'}
        </button>
        <button
          type="button"
          className="settings-modal__action-btn settings-modal__action-btn--ghost"
          disabled={inviteBusy}
          onClick={onDismiss}
        >
          Not now
        </button>
      </div>
    </section>
  );
}
